/**
 * @file Generated by js-routes 2.3.5. Based on Rails 8.0.2 routes of InertiaRailsShadcnStarter::Application.
 * @version e55897628786330b45b4fe8f2f0a05dc950b2db98714f3d5b24ae6bb1d6f3fd2
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_revisions/:id/accept(.:format)
 * @param {any} businessAccountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptAgencyBusinessAccountPlanRevisionPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_revisions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses/:uid/access(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accessAdminCoursePath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/invoices/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountsVendorInvoicesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/to_dos/:id/acknowledge(.:format)
 * @param {any} businessUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acknowledgeBusinessToDoPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"to_dos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"acknowledge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/added_products/:slug/activate(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateAgencyAddedProductPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"added_products"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/subscription/activate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateAgencySettingsSubscriptionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/activation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminActivationDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/added_products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAddedProductPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"added_products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/added_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAddedProductsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"added_products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/administrators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAdministratorPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"administrators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/administrators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAdministratorsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"administrators"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/accounts/:account_id/payouts/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateAccountPayoutPath = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/accounts/:account_id/payouts(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateAccountPayoutsPath = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"payouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/accounts/:account_id/tax_form(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateAccountTaxFormPath = /*#__PURE__*/ __jsr.r({"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"tax_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/affiliate_account_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateAffiliateAccountAccessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"affiliate_account_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/asset_folders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateAssetFolderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"asset_folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/asset_folders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateAssetFoldersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"asset_folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/asset_library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateAssetLibraryIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"asset_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/commissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateCommissionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"commissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/projects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateProjectPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/projects/:project_id/links/:code(.:format)
 * @param {any} projectId
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateProjectLinkPath = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/projects/:project_id/links(.:format)
 * @param {any} projectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateProjectLinksPath = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/training_videos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateTrainingVideoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"training_videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/training_videos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAffiliateTrainingVideosPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"training_videos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAgencyAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_account_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAgencyAccountAccessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_account_access"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_accounts/:agency_account_id/activation(.:format)
 * @param {any} agencyAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAgencyAccountActivationPath = /*#__PURE__*/ __jsr.r({"agency_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_accounts"],[2,[7,"/"],[2,[3,"agency_account_id"],[2,[7,"/"],[2,[6,"activation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_accounts/:agency_account_id/affiliate_project_assignment(.:format)
 * @param {any} agencyAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAgencyAccountAffiliateProjectAssignmentPath = /*#__PURE__*/ __jsr.r({"agency_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_accounts"],[2,[7,"/"],[2,[3,"agency_account_id"],[2,[7,"/"],[2,[6,"affiliate_project_assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_accounts/:agency_account_id/credit_adjustment(.:format)
 * @param {any} agencyAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAgencyAccountCreditAdjustmentPath = /*#__PURE__*/ __jsr.r({"agency_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_accounts"],[2,[7,"/"],[2,[3,"agency_account_id"],[2,[7,"/"],[2,[6,"credit_adjustment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_accounts/:agency_account_id/feature_flags(.:format)
 * @param {any} agencyAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAgencyAccountFeatureFlagsPath = /*#__PURE__*/ __jsr.r({"agency_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_accounts"],[2,[7,"/"],[2,[3,"agency_account_id"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAgencyAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_subscription_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAgencySubscriptionInvoicesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_subscription_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_subscription_plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAgencySubscriptionPlanPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_subscription_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_subscription_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAgencySubscriptionPlansPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_subscription_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/analysis_feedbacks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAnalysisFeedbackPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"analysis_feedbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/analysis_feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAnalysisFeedbacksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"analysis_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAnnouncementPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAnnouncementsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_account_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessAccountAccessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_account_access"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_accounts/:business_account_id/ad_campaign_links/:id(.:format)
 * @param {any} businessAccountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessAccountAdCampaignLinkPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"ad_campaign_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_accounts/:business_account_id/ad_campaign_links(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessAccountAdCampaignLinksPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"ad_campaign_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_accounts/:business_account_id/invoices/:id(.:format)
 * @param {any} businessAccountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessAccountInvoicePath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBusinessAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp-content/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCheckMcpContentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp-content"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/coupons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCouponPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"coupons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/coupons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCouponsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"coupons"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses/:uid(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCoursePath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses/:course_uid/agency_assignments/:id(.:format)
 * @param {any} courseUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCourseAgencyAssignmentPath = /*#__PURE__*/ __jsr.r({"course_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_uid"],[2,[7,"/"],[2,[6,"agency_assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses/:course_uid/agency_assignments(.:format)
 * @param {any} courseUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCourseAgencyAssignmentsPath = /*#__PURE__*/ __jsr.r({"course_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_uid"],[2,[7,"/"],[2,[6,"agency_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses/:course_uid/chapters/:uid(.:format)
 * @param {any} courseUid
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCourseChapterPath = /*#__PURE__*/ __jsr.r({"course_uid":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_uid"],[2,[7,"/"],[2,[6,"chapters"],[2,[7,"/"],[2,[3,"uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses/:course_uid/chapters(.:format)
 * @param {any} courseUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCourseChaptersPath = /*#__PURE__*/ __jsr.r({"course_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_uid"],[2,[7,"/"],[2,[6,"chapters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses/:course_uid/sessions/:uid(.:format)
 * @param {any} courseUid
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCourseSessionPath = /*#__PURE__*/ __jsr.r({"course_uid":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_uid"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses/:course_uid/sessions(.:format)
 * @param {any} courseUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCourseSessionsPath = /*#__PURE__*/ __jsr.r({"course_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_uid"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCoursesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/credit_prices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCreditPricesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"credit_prices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/data_verification_issues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDataVerificationIssuesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_verification_issues"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/held_briefs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminHeldBriefsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"held_briefs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ipromote/campaign_opportunities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminIpromoteCampaignOpportunitiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ipromote"],[2,[7,"/"],[2,[6,"campaign_opportunities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ipromote/campaign_opportunities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminIpromoteCampaignOpportunityPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ipromote"],[2,[7,"/"],[2,[6,"campaign_opportunities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/gantt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminJobRunsReportPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gantt"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/keyword_analyzer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminKeywordAnalyzerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"keyword_analyzer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/keyword_analyzer/lab_runs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminKeywordAnalyzerLabRunPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"keyword_analyzer"],[2,[7,"/"],[2,[6,"lab_runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/keyword_analyzer/lab_runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminKeywordAnalyzerLabRunsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"keyword_analyzer"],[2,[7,"/"],[2,[6,"lab_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/keyword_analyzer/prompt_configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminKeywordAnalyzerPromptConfigsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"keyword_analyzer"],[2,[7,"/"],[2,[6,"prompt_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMarketingPlanPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketing_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMarketingPlansPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"marketing_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp-content/*key
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMcpContentPath = /*#__PURE__*/ __jsr.r({"key":{"r":true}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp-content"],[2,[7,"/"],[5,[3,"key"]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp-content/versions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMcpContentVersionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp-content"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp-content(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminMcpContentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp-content"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOneTimeProductPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOneTimeProductsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminProductPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_carts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminProductCartPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_carts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_carts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminProductCartsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_carts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminProductsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/prospecting_activations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminProspectingActivationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prospecting_activations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/top_niches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminProspectingTopNichePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"top_niches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/top_niches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminProspectingTopNichesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"top_niches"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp-content/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminResetMcpContentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp-content"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRunDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales/businesses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSalesBusinessesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"businesses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales_dfy_assignments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSalesDfyAssignmentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales_dfy_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSalesInvoicesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales/leads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSalesLeadPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales/leads/:lead_id/sales_rep(.:format)
 * @param {any} leadId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSalesLeadSalesRepPath = /*#__PURE__*/ __jsr.r({"lead_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"lead_id"],[2,[7,"/"],[2,[6,"sales_rep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales/leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSalesLeadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales/meetings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSalesMeetingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"meetings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales/meetings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSalesMeetingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"meetings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/site-prompts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSiteBuildPromptPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"site-prompts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/site-prompts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSiteBuildPromptsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"site-prompts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/solo_plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSoloPlanPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"solo_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/solo_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSoloPlansPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"solo_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscription_offers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSubscriptionOfferPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscription_offers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscription_offers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSubscriptionOffersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscription_offers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/upsell_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUpsellLinksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"upsell_links"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_account_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorAccountAccessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_account_access"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_invoices/:uid(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorInvoicePath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_invoices"],[2,[7,"/"],[2,[3,"uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorInvoicesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_orders/:vendor_order_id/cancellation(.:format)
 * @param {any} vendorOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorOrderCancellationPath = /*#__PURE__*/ __jsr.r({"vendor_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_orders"],[2,[7,"/"],[2,[3,"vendor_order_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVendorOrdersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/wix_referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminWixReferralsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"wix_referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /affiliate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliateAccountRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /affiliate/commissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliateCommissionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"commissions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /affiliate/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliateDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /affiliate/hub(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliateHubPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"hub"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /signup/r/:referral_code(.:format)
 * @param {any} referralCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliateLaunchSignupPath = /*#__PURE__*/ __jsr.r({"referral_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signup"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"referral_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /l/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliateLinkRedirectPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /affiliate/payout_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliatePayoutDetailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"payout_details"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /affiliate/payout_methods/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliatePayoutMethodPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"payout_methods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /affiliate/payout_methods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliatePayoutMethodsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"payout_methods"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /affiliate/tax_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliateTaxFormPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"tax_form"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/invitations/:token/accept(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyAcceptAgencyInvitationPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyAccountRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agency/switch/:uid(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyAccountSwitchPath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"switch"],[2,[7,"/"],[2,[3,"uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/added_products/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyAddedProductPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"added_products"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/added_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyAddedProductsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"added_products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses/agency_autocomplete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyAutocompleteAdminCoursesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[6,"agency_autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_account_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountAccessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_account_access"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_agreements/images(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountAgreementImagesPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_agreements"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/conversational_ai_order(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountConversationalAiOrderPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"conversational_ai_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/discovery_profile(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountDiscoveryProfilePath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"discovery_profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_account_invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountInvoicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_account_invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_account_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountInvoicesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_account_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/leads/:lead_id/quality(.:format)
 * @param {any} businessAccountId
 * @param {any} leadId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountLeadQualityPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"lead_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"lead_id"],[2,[7,"/"],[2,[6,"quality"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/operator_mandate(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountOperatorMandatePath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"operator_mandate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_agreements/:uid(.:format)
 * @param {any} businessAccountId
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountPlanAgreementPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_agreements"],[2,[7,"/"],[2,[3,"uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_agreements(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountPlanAgreementsPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_agreements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_revisions(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountPlanRevisionsPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_revisions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/purchased_products/:slug(.:format)
 * @param {any} businessAccountId
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountPurchasedProductPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"purchased_products"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/quote_requests/:id(.:format)
 * @param {any} businessAccountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountQuoteRequestPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"quote_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/quote_requests/:quote_request_id/cancellation(.:format)
 * @param {any} businessAccountId
 * @param {any} quoteRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountQuoteRequestCancellationPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"quote_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"quote_requests"],[2,[7,"/"],[2,[3,"quote_request_id"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/quote_requests/:quote_request_id/cart(.:format)
 * @param {any} businessAccountId
 * @param {any} quoteRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountQuoteRequestCartPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"quote_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"quote_requests"],[2,[7,"/"],[2,[3,"quote_request_id"],[2,[7,"/"],[2,[6,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/quote_requests/:quote_request_id/messages(.:format)
 * @param {any} businessAccountId
 * @param {any} quoteRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountQuoteRequestMessagesPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"quote_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"quote_requests"],[2,[7,"/"],[2,[3,"quote_request_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/quote_requests(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountQuoteRequestsPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"quote_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/solo_cart(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountSoloCartPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"solo_cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/solo_cart_products/:slug(.:format)
 * @param {any} businessAccountId
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountSoloCartProductPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"solo_cart_products"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/solo_checkout(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountSoloCheckoutPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"solo_checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/solo_plans(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountSoloPlansPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"solo_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/website_order(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountWebsiteOrderPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"website_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/businesses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyBusinessesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"businesses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/demo_tour(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyDemoTourPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"demo_tour"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/sites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyGeneratedSitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyIntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/imports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyLeadImportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyLeadImportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/activate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyLeadsActivatePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/manual(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyManualLeadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"manual"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/marketing_analyses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyMarketingAnalysesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"marketing_analyses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/marketing_analysis_archivals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyMarketingAnalysisArchivalPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"marketing_analysis_archivals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/marketing_analysis_archivals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyMarketingAnalysisArchivalsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"marketing_analysis_archivals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/operator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyOperatorPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"operator"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/pricing_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyPricingGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"pricing_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/pricing_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyPricingGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"pricing_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProductPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProductsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/prospects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/prospects/:prospect_id/contacts/:id(.:format)
 * @param {any} prospectId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectContactPath = /*#__PURE__*/ __jsr.r({"prospect_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"prospect_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/prospects/:prospect_id/contacts(.:format)
 * @param {any} prospectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectContactsPath = /*#__PURE__*/ __jsr.r({"prospect_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"prospect_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/prospects/:prospect_id/sales_notes(.:format)
 * @param {any} prospectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectSalesNotesPath = /*#__PURE__*/ __jsr.r({"prospect_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"prospect_id"],[2,[7,"/"],[2,[6,"sales_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectSearchPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectSearchesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/prospects/:prospect_id/edits(.:format)
 * @param {any} prospectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectSiteEditRequestsPath = /*#__PURE__*/ __jsr.r({"prospect_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"prospect_id"],[2,[7,"/"],[2,[6,"edits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/prospects/:prospect_id/social_links(.:format)
 * @param {any} prospectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectSocialLinksPath = /*#__PURE__*/ __jsr.r({"prospect_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"prospect_id"],[2,[7,"/"],[2,[6,"social_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/prospects/:prospect_id/wix_account_email(.:format)
 * @param {any} prospectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectWixAccountEmailPath = /*#__PURE__*/ __jsr.r({"prospect_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"prospect_id"],[2,[7,"/"],[2,[6,"wix_account_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/prospects/:prospect_id/wix_setup(.:format)
 * @param {any} prospectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectWixSetupPath = /*#__PURE__*/ __jsr.r({"prospect_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"prospect_id"],[2,[7,"/"],[2,[6,"wix_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/activate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectingActivationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/prospecting_analyses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectingAnalysesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"prospecting_analyses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/autopilot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectingAutopilotPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"autopilot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/credit_packs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyProspectingCreditPurchasesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"credit_packs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/reactivate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyReactivatePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/referral_hub(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyReferralHubPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"referral_hub"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/referral_links/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyReferralLinkPath = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"referral_links"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/referral_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyReferralLinksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"referral_links"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/agent_connections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsAgentConnectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"agent_connections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/agent_connections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsAgentConnectionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"agent_connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsBillingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/custom_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsCustomDomainPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/sales_dfy_enrollment/finalize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsFinalizeSalesDfyEnrollmentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_dfy_enrollment"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/invoice_configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsInvoiceConfigurationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"invoice_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/payment_method(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsPaymentMethodPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payment_method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/sales_dfy_enrollment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsSalesDfyEnrollmentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sales_dfy_enrollment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/sender_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsSenderDomainPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sender_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsSubscriptionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/talk_to_human(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsTalkToHumanPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"talk_to_human"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsUpgradePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/website(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsWebsitePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"website"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/website_claim(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsWebsiteClaimPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"website_claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/whitelabel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySettingsWhitelabelPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"whitelabel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signup/agency/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySignupConfirmPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signup/agency/setup_intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySignupSetupIntentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"setup_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signup/agency/upsell(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySignupUpsellPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"upsell"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signup/agency/upsell/finalize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySignupUpsellFinalizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"upsell"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /signup/agency/upsell/setup_intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySignupUpsellSetupIntentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"upsell"],[2,[7,"/"],[2,[6,"setup_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /signup/agency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySignupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[2,[7,"/"],[2,[6,"agency"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/stripe_connect/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyStripeConnectCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/stripe_connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyStripeConnectDisconnectPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"stripe_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/stripe_connect/start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyStripeConnectStartPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/stripe_connect/sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyStripeConnectSyncPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/subscription_inactive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencySubscriptionInactivePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"subscription_inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/training/:uid(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyTrainingPath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[3,"uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/training(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyTrainingIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"training"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/trial_expired(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyTrialExpiredPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"trial_expired"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agencyWixReferralsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/:id/analyze(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyzeAgencyProspectSearchPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"analyze"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:id/dismiss(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcementDismissPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcementsFeedPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/gleap/marketing_analysis_context(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiGleapMarketingAnalysisContextPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"gleap"],[2,[7,"/"],[2,[6,"marketing_analysis_context"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/gleap/pricing_context(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiGleapPricingContextPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"gleap"],[2,[7,"/"],[2,[6,"pricing_context"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/places/autocomplete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiPlacesAutocompletePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"places"],[2,[7,"/"],[2,[6,"autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/places/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiPlacesDetailsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"places"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_invoices/:uid/approve(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveAdminVendorInvoicePath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_invoices"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/operator_actions/:id/approve(.:format)
 * @param {any} businessAccountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveAgencyBusinessAccountOperatorActionPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"operator_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/operator_runs/:id/approve(.:format)
 * @param {any} businessAccountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveAgencyBusinessAccountOperatorRunPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"operator_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/prospects/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveAgencyProspectPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveAgencyProspectSearchPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/accounts/autocomplete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const autocompleteAdminAffiliateAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/website/availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const availabilityAgencySettingsWebsitePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/invitations/:token/accept(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessAcceptInvitationPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/accounts_passthru(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessAccountsPassthruPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[6,"accounts_passthru"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/to_dos/:to_do_id/conversion_sharing_consent/allow(.:format)
 * @param {any} businessUid
 * @param {any} toDoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessAllowToDoConversionSharingConsentPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"to_do_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"to_dos"],[2,[7,"/"],[2,[3,"to_do_id"],[2,[7,"/"],[2,[6,"conversion_sharing_consent"],[2,[7,"/"],[2,[6,"allow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/analysis(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessAnalysisPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/analysis/:id(.:format)
 * @param {any} businessUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessAnalysisResultPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/to_dos/:to_do_id/conversion_sharing_consent/decline(.:format)
 * @param {any} businessUid
 * @param {any} toDoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessDeclineToDoConversionSharingConsentPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"to_do_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"to_dos"],[2,[7,"/"],[2,[3,"to_do_id"],[2,[7,"/"],[2,[6,"conversion_sharing_consent"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/demo_tour(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessDemoTourPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"demo_tour"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/discovery(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessDiscoveryPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"discovery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/inbox(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessInboxPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/inbox/:group(.:format)
 * @param {any} businessUid
 * @param {any} group
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessInboxConversationPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"group":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"group"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/inbox/:group/messages(.:format)
 * @param {any} businessUid
 * @param {any} group
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessInboxMessagesPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"group":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"group"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/inbox/:group/read(.:format)
 * @param {any} businessUid
 * @param {any} group
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessInboxReadPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"group":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"group"],[2,[7,"/"],[2,[6,"read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/inbox/:group/unread(.:format)
 * @param {any} businessUid
 * @param {any} group
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessInboxUnreadPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"group":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"group"],[2,[7,"/"],[2,[6,"unread"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessIntegrationsPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/facebook(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessIntegrationsFacebookPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"facebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/gbp(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessIntegrationsGbpPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gbp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/gsc(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessIntegrationsGscPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gsc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/leads/:id(.:format)
 * @param {any} businessUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessLeadPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/leads/conversations/:conversation_id(.:format)
 * @param {any} businessUid
 * @param {any} conversationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessLeadConversationPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"conversation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/leads/:lead_id/interactions/:interaction_uid/recording(.:format)
 * @param {any} businessUid
 * @param {any} leadId
 * @param {any} interactionUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessLeadInteractionRecordingPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"lead_id":{"r":true},"interaction_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"lead_id"],[2,[7,"/"],[2,[6,"interactions"],[2,[7,"/"],[2,[3,"interaction_uid"],[2,[7,"/"],[2,[6,"recording"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/lead_notification_settings(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessLeadNotificationSettingsPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"lead_notification_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/lead_notification_test(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessLeadNotificationTestPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"lead_notification_test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/lead_notification_test/report_error(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessLeadNotificationTestReportErrorPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"lead_notification_test"],[2,[7,"/"],[2,[6,"report_error"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/leads/:lead_id/quality(.:format)
 * @param {any} businessUid
 * @param {any} leadId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessLeadQualityPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"lead_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"lead_id"],[2,[7,"/"],[2,[6,"quality"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/leads(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessLeadsPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/marketing_plan(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMarketingPlanPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"marketing_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/messages(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessMessagesPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/profile/brand_story(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessProfileBrandStoryPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"brand_story"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/profile/media_library/:uid(.:format)
 * @param {any} businessUid
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessProfileMediaAssetPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"media_library"],[2,[7,"/"],[2,[3,"uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/profile/media_library(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessProfileMediaAssetsPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"media_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/progress_reports/:uid(.:format)
 * @param {any} businessUid
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessProgressReportPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"progress_reports"],[2,[7,"/"],[2,[3,"uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/to_dos/:to_do_id/wix_domain/purchase(.:format)
 * @param {any} businessUid
 * @param {any} toDoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessPurchaseToDoWixDomainPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"to_do_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"to_dos"],[2,[7,"/"],[2,[3,"to_do_id"],[2,[7,"/"],[2,[6,"wix_domain"],[2,[7,"/"],[2,[6,"purchase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/reporting(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessReportingPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"reporting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessRootPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales/meetings/business_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessSearchAdminSalesMeetingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"meetings"],[2,[7,"/"],[2,[6,"business_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/settings/billing(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessSettingsBillingIndexPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/settings/users/:id(.:format)
 * @param {any} businessUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessSettingsUserPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/settings/users(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessSettingsUsersPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/sms_addon(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessSmsAddonPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"sms_addon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/to_dos/:id(.:format)
 * @param {any} businessUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessToDoPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"to_dos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/to_dos/:to_do_id/task_submission(.:format)
 * @param {any} businessUid
 * @param {any} toDoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessToDoTaskSubmissionPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"to_do_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"to_dos"],[2,[7,"/"],[2,[3,"to_do_id"],[2,[7,"/"],[2,[6,"task_submission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/to_dos(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessToDosPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"to_dos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/to_dos/:to_do_id/website_domain/verify(.:format)
 * @param {any} businessUid
 * @param {any} toDoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessVerifyToDoWebsiteDomainPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"to_do_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"to_dos"],[2,[7,"/"],[2,[3,"to_do_id"],[2,[7,"/"],[2,[6,"website_domain"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/to_dos/:to_do_id/wix_domain/verify(.:format)
 * @param {any} businessUid
 * @param {any} toDoId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessVerifyToDoWixDomainPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"to_do_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"to_dos"],[2,[7,"/"],[2,[3,"to_do_id"],[2,[7,"/"],[2,[6,"wix_domain"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/yext_categories(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessYextCategoriesPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"yext_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/yext_sso(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const businessYextSsoPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"yext_sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/prospecting_analyses/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelAgencyProspectingAnalysisPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"prospecting_analyses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/credit_prices/:action_key/cancel_scheduled(.:format)
 * @param {any} actionKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelScheduledAdminCreditPricePath = /*#__PURE__*/ __jsr.r({"action_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"credit_prices"],[2,[7,"/"],[2,[3,"action_key"],[2,[7,"/"],[2,[6,"cancel_scheduled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelUserRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/growth_plans/:uid/cancellation(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancellationAgencySettingsGrowthPlanPath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"growth_plans"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/training/:uid/certificate(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certificateAgencyTrainingPath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/chat(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/chat/embed(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatEmbedPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/projects/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cloneAdminAffiliateProjectPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/training/:uid/sessions/:session_uid/complete(.:format)
 * @param {any} uid
 * @param {any} sessionUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeSessionAgencyTrainingPath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"session_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"session_uid"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/imports/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmAgencyLeadImportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/prospecting_analyses/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmAgencyProspectingAnalysisPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"prospecting_analyses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/website_claim/confirm/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmAgencySettingsWebsiteClaimPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"website_claim"],[2,[7,"/"],[2,[6,"confirm"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/checkout/confirmation(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmationPlanMarketingAnalysisCheckoutPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/facebook/connect_account(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectAccountBusinessIntegrationsFacebookPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"connect_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/gbp/connect_locations(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectLocationsBusinessIntegrationsGbpPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gbp"],[2,[7,"/"],[2,[6,"connect_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/gsc/connect_site(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectSiteBusinessIntegrationsGscPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gsc"],[2,[7,"/"],[2,[6,"connect_site"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/analysis_runner/session/consume(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consumeInternalAnalysisRunnerSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"analysis_runner"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"consume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_agreements/:uid/countersign(.:format)
 * @param {any} businessAccountId
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const countersignAgencyBusinessAccountPlanAgreementPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_agreements"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"countersign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /coupons/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const couponPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"coupons"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/asset_library/assets/:folder_id(.:format)
 * @param {any} folderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createAssetAdminAffiliateAssetLibraryIndexPath = /*#__PURE__*/ __jsr.r({"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"folder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/website/custom_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customDomainAgencySettingsWebsitePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[6,"custom_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/credit_prices/:action_key/deactivate(.:format)
 * @param {any} actionKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivateAdminCreditPricePath = /*#__PURE__*/ __jsr.r({"action_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"credit_prices"],[2,[7,"/"],[2,[3,"action_key"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/added_products/:slug/deactivate(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivateAgencyAddedProductPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"added_products"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/demo/chat(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const demoChatPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/demo/chat/complete(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const demoChatCompletePath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/asset_library/assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyAssetAdminAffiliateAssetLibraryIndexPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/operator_runs/:id/discard(.:format)
 * @param {any} businessAccountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discardAgencyBusinessAccountOperatorRunPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"operator_runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/facebook/disconnect(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnectBusinessIntegrationsFacebookPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"disconnect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/gbp/disconnect(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnectBusinessIntegrationsGbpPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gbp"],[2,[7,"/"],[2,[6,"disconnect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/gsc/disconnect(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnectBusinessIntegrationsGscPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gsc"],[2,[7,"/"],[2,[6,"disconnect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/settings/integrations/gbp/disconnect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnectVendorSettingsGbpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gbp"],[2,[7,"/"],[2,[6,"disconnect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_carts/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateAdminProductCartPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_carts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/projects/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminAffiliateProjectPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminAgencyAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_subscription_plans/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminAgencySubscriptionPlanPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_subscription_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminAnnouncementPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminBusinessAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/coupons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCouponPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"coupons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminOneTimeProductPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminProductPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_carts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminProductCartPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_carts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscription_offers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminSubscriptionOfferPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscription_offers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminVendorAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/added_products/:slug/edit(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAgencyAddedProductPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"added_products"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAgencyBusinessAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_agreements/:uid/edit(.:format)
 * @param {any} businessAccountId
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAgencyBusinessAccountPlanAgreementPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_agreements"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/account/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAgencySettingsAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/invoice_configuration/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAgencySettingsInvoiceConfigurationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"invoice_configuration"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/talk_to_human/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAgencySettingsTalkToHumanPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"talk_to_human"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_subscription_block(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailSubscriptionBlockPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_subscription_block"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/commissions/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportAdminAffiliateCommissionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"commissions"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/prospecting_activations/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportAdminProspectingActivationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prospecting_activations"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/runs/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportAdminRunDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_account_invoices/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportAgencyBusinessAccountInvoicesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_account_invoices"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportAgencyBusinessAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/sites/:id/export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportAgencyGeneratedSitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/credit_packs/finalize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalizeAgencyProspectingCreditPurchasesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"credit_packs"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/:id/find_contacts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const findContactsAgencyProspectSearchPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"find_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/added_products/:id/force_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forceStateAdminAddedProductPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"added_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"force_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/:id/generate_impact_reports(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateImpactReportsAgencyProspectSearchPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_impact_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/:id/generate_sites(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateSitesAgencyProspectSearchPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_sites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/overview/goal(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goalPlanMarketingAnalysisOverviewPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[6,"goal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /handoff/wix/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const handoffWixOrderPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"handoff"],[2,[7,"/"],[2,[6,"wix"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /handoff/wix/:token/report(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const handoffWixOrderReportPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"handoff"],[2,[7,"/"],[2,[6,"wix"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /handoff/wix/:token/site(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const handoffWixOrderSitePath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"handoff"],[2,[7,"/"],[2,[6,"wix"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"site"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_orders/:id/impersonate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const impersonateAdminVendorOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"impersonate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/analysis_runner/session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAnalysisRunnerSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"analysis_runner"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const joinRootPath = /*#__PURE__*/ __jsr.r({"subdomain":{"d":"join"}}, [7,"/"]);

/**
 * Generates rails route to
 * /signup/launch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const launchSignupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[2,[7,"/"],[2,[6,"launch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/autopilot/leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leadsAgencyProspectingAutopilotPath = /*#__PURE__*/ __jsr.r({"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"autopilot"],[2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/keyword_analyzer/load_context(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loadContextAdminKeywordAnalyzerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"keyword_analyzer"],[2,[7,"/"],[2,[6,"load_context"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/settings/users/:id/make_owner(.:format)
 * @param {any} businessUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makeOwnerBusinessSettingsUserPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"make_owner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/pricing_groups/:id/markups(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markupsAgencyPricingGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"pricing_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"markups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mcp/support(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcpSupportPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"support"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/top_niches/:id/move(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveAdminProspectingTopNichePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"top_niches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize/native(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nativeOauthAuthorizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/projects/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminAffiliateProjectPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminAgencyAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_subscription_plans/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminAgencySubscriptionPlanPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_subscription_plans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminAnnouncementPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/coupons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCouponPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"coupons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ipromote/campaign_opportunities/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminIpromoteCampaignOpportunityPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ipromote"],[2,[7,"/"],[2,[6,"campaign_opportunities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/one_time_products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminOneTimeProductPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"one_time_products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_carts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminProductCartPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_carts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscription_offers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminSubscriptionOfferPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscription_offers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminVendorAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/added_products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAgencyAddedProductPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"added_products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAgencyBusinessAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_agreements/new(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAgencyBusinessAccountPlanAgreementPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_agreements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/website_order/new(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAgencyBusinessAccountWebsiteOrderPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"website_order"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/upgrade/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAgencySettingsUpgradePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"upgrade"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /signup/agency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAgencySignupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[2,[7,"/"],[2,[6,"agency"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/messages/new(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBusinessMessagePath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/onboardings/new(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPlanOnboardingPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailSourcePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/messages/new(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newVendorOrderMessagePath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /nimbata/webhook/:business_uid(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nimbataWebhookPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"nimbata"],[2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[3,"business_uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /no_active_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const noActiveAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"no_active_account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthAuthorizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business/integrations/facebook/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthFacebookCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/integrations/gbp/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthGbpCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gbp"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/integrations/gsc/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthGscCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gsc"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/introspect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthIntrospectPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthRegisterPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthRevokePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthTokenPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/token/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthTokenInfoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/settings/integrations/gbp/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthVendorGbpCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gbp"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/onboarding/discovery_fit(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingDiscoveryFitPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"discovery_fit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/onboarding/messages(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingMessagesPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/onboarding/session(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingSessionPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/onboarding/signup(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingSignupPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/purchased_products/:slug/pause(.:format)
 * @param {any} businessAccountId
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pauseAgencyBusinessAccountPurchasedProductPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"purchased_products"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/growth_plans/:uid/pause(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pauseAgencySettingsGrowthPlanPath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"growth_plans"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/subscription/pause(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pauseAgencySettingsSubscriptionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_agreements/:uid/pdf(.:format)
 * @param {any} businessAccountId
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdfAgencyBusinessAccountPlanAgreementPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_agreements"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_plans/:id/phases(.:format)
 * @param {any} agencyUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phasesPlanMarketingPlanPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"phases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/profile/media_library/picker(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pickerBusinessProfileMediaAssetsPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"media_library"],[2,[7,"/"],[2,[6,"picker"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/agreements/sign/:token(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"agreements"],[2,[7,"/"],[2,[6,"sign"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/agreements/sign/:token(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planAgreementSigningPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"agreements"],[2,[7,"/"],[2,[6,"sign"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/agreements/sign/:token/pdf(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planAgreementSigningPdfPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"agreements"],[2,[7,"/"],[2,[6,"sign"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/cart_invite/:token(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planCartInvitePath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"cart_invite"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/agreements/sign/:token/decline(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planDeclineAgreementSigningPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"agreements"],[2,[7,"/"],[2,[6,"sign"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:id(.:format)
 * @param {any} agencyUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/analysis_feedback(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisAnalysisFeedbackPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"analysis_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/budgets(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisBudgetsPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"budgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/checkout(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisCheckoutPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/impact_report(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisImpactReportPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"impact_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/impact_report/business_data(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisImpactReportBusinessDataPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"impact_report"],[2,[7,"/"],[2,[6,"business_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/impact_report/clients_goal(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisImpactReportClientsGoalPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"impact_report"],[2,[7,"/"],[2,[6,"clients_goal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/impact_report/demo_tour(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisImpactReportDemoTourPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"impact_report"],[2,[7,"/"],[2,[6,"demo_tour"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/impact_report/presented_plan(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisImpactReportPresentedPlanPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"impact_report"],[2,[7,"/"],[2,[6,"presented_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/loader(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisLoaderPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"loader"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/loading(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisLoadingPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"loading"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/overview(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisOverviewPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/plan(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisPlanPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/pre_plan_questions(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisPrePlanQuestionsPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"pre_plan_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/pre_plan_questions(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisPrePlanQuestionsUpdatePath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"pre_plan_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/results/:id(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisResultPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"results"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/results(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisResultsPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/share/:token(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisSharePath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[6,"share"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/share_editors/:user_uid(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {any} userUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisShareEditorPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"user_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"share_editors"],[2,[7,"/"],[2,[3,"user_uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/share_editors(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisShareEditorsPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"share_editors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/share_events(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisShareEventsPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"share_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/share/:token/og.png(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisShareOgImagePath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[6,"share"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"og"],[2,[8,"."],[2,[6,"png"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/share/:token/overview(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisShareOverviewPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[6,"share"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/share/:token/plans/:plan_uid(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {any} planUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisSharePlanPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"plan_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[6,"share"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"plan_uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/share/:token/results/:id(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisShareResultPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[6,"share"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"results"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/status(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingAnalysisStatusPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_plans/:id(.:format)
 * @param {any} agencyUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingPlanPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_plans/:marketing_plan_id/projection_status(.:format)
 * @param {any} agencyUid
 * @param {any} marketingPlanId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingPlanProjectionStatusPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_plans"],[2,[7,"/"],[2,[3,"marketing_plan_id"],[2,[7,"/"],[2,[6,"projection_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_plans/share/:token(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planMarketingPlanSharePath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_plans"],[2,[7,"/"],[2,[6,"share"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/onboardings/:id(.:format)
 * @param {any} agencyUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planOnboardingPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planOnboardingRootPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/onboardings/:id/step/:step_key(.:format)
 * @param {any} agencyUid
 * @param {any} id
 * @param {any} stepKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planOnboardingStepPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"id":{"r":true},"step_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"step"],[2,[7,"/"],[2,[3,"step_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/onboardings/:id/step/:step_key(.:format)
 * @param {any} agencyUid
 * @param {any} id
 * @param {any} stepKey
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planOnboardingStepUpdatePath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"id":{"r":true},"step_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"step"],[2,[7,"/"],[2,[3,"step_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/onboardings(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planOnboardingsPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"onboardings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/solo/checkout/:token(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planSoloCheckoutPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"solo"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/solo/checkout/:token/confirmation(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planSoloCheckoutConfirmationPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"solo"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/solo/checkout/:token(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planSoloCheckoutPaymentPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"solo"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/solo/checkout/:token/tax_preview(.:format)
 * @param {any} agencyUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planSoloCheckoutTaxPreviewPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"solo"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"tax_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/site-prompts/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewAdminSiteBuildPromptPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"site-prompts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/invoice_configuration/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewAgencySettingsInvoiceConfigurationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"invoice_configuration"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:slug/checkout(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCartCheckoutPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:slug/checkout/account(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCartCheckoutAccountPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:slug/checkout/confirm(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCartCheckoutConfirmPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:slug/checkout/setup_intent(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCartCheckoutSetupIntentPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"setup_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:slug/checkout/success(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productCartCheckoutSuccessPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productLandingPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/:slug/purchased(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productLandingPurchasedPath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"purchased"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/:slug/terms_acceptance(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productLandingTermsAcceptancePath = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"terms_acceptance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agency/training/:uid/progress(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const progressAgencyTrainingPath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"training"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /prospecting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prospectingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prospecting"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /prospecting/activate/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prospectingActivatePath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prospecting"],[2,[7,"/"],[2,[6,"activate"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /prospecting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prospectingSignupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prospecting"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agency/settings/website/provision(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const provisionAgencySettingsWebsitePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[6,"provision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp-content/versions/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publishAdminMcpContentVersionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp-content"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_agreements/:uid/publish(.:format)
 * @param {any} businessAccountId
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publishAgencyBusinessAccountPlanAgreementPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_agreements"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationProxyPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailIncineratePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailReroutePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailSourcesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDirectUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encodedKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsHealthCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailgunInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundHealthCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsPostmarkInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsRelayInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsSendgridInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobProxyPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/growth_plans/:uid/reactivate(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reactivateAgencySettingsGrowthPlanPath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"growth_plans"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:referral_code(.:format)
 * @param {any} referralCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralPath = /*#__PURE__*/ __jsr.r({"referral_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"referral_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/purchased_products/:slug/refund(.:format)
 * @param {any} businessAccountId
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refundAgencyBusinessAccountPurchasedProductPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"purchased_products"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_agreements/:uid/regenerate(.:format)
 * @param {any} businessAccountId
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerateAgencyBusinessAccountPlanAgreementPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_agreements"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"regenerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_invoices/:uid/reject(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectAdminVendorInvoicePath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_invoices"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/operator_actions/:id/reject(.:format)
 * @param {any} businessAccountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectAgencyBusinessAccountOperatorActionPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"operator_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses/:uid/reorder_chapters(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderChaptersAdminCoursePath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"reorder_chapters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/courses/:course_uid/chapters/:uid/reorder_sessions(.:format)
 * @param {any} courseUid
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderSessionsAdminCourseChapterPath = /*#__PURE__*/ __jsr.r({"course_uid":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_uid"],[2,[7,"/"],[2,[6,"chapters"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"reorder_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/to_dos/:id/reply(.:format)
 * @param {any} businessUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const replyBusinessToDoPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"to_dos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_agreements/:uid/resend(.:format)
 * @param {any} businessAccountId
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendAgencyBusinessAccountPlanAgreementPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_agreements"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mcp-content/versions/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreAdminMcpContentVersionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mcp-content"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/prospects/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreAgencyProspectPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreAgencyProspectSearchPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/purchased_products/:slug/resume(.:format)
 * @param {any} businessAccountId
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resumeAgencyBusinessAccountPurchasedProductPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"purchased_products"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/subscription/resume(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resumeAgencySettingsSubscriptionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize/resume(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resumeOauthAuthorizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_accounts/:id/retry_nimbata_tracking(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryNimbataTrackingAdminBusinessAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_nimbata_tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /agency/business_accounts/:id/run_analysis(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runAnalysisAgencyBusinessAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sdfy/book/:agency_uid(.:format)
 * @param {any} agencyUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesDfyBookingPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sdfy"],[2,[7,"/"],[2,[6,"book"],[2,[7,"/"],[2,[3,"agency_uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/subscription/scheduled_deletion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduledDeletionAgencySettingsSubscriptionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"scheduled_deletion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/growth_plans/:uid/scheduled_transition(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduledTransitionAgencySettingsGrowthPlanPath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"growth_plans"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"scheduled_transition"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/sites/:id/share(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareAgencyGeneratedSitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/prospecting_analyses/:id/share(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareAgencyProspectingAnalysisPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"prospecting_analyses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:share_token(.:format)
 * @param {any} shareToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sharedSitePath = /*#__PURE__*/ __jsr.r({"share_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"share_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiqWebPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /signup/agency/upsell(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signupAgencyUpsellPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"upsell"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /site-qa/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const siteQaPreviewPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"site-qa"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s/:share_token/site(.:format)
 * @param {any} shareToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const siteSharedSitePath = /*#__PURE__*/ __jsr.r({"share_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"share_token"],[2,[7,"/"],[2,[6,"site"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/imports/:id/skipped(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skippedAgencyLeadImportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"skipped"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/phone/snooze(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const snoozeUserProfilePhonePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"phone"],[2,[7,"/"],[2,[6,"snooze"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/website/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ssoAgencySettingsWebsitePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/facebook/start_oauth(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startOauthBusinessIntegrationsFacebookPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"start_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/gbp/start_oauth(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startOauthBusinessIntegrationsGbpPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gbp"],[2,[7,"/"],[2,[6,"start_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/gsc/start_oauth(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startOauthBusinessIntegrationsGscPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gsc"],[2,[7,"/"],[2,[6,"start_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/settings/integrations/gbp/start_oauth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startOauthVendorSettingsGbpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gbp"],[2,[7,"/"],[2,[6,"start_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/custom_domain/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusAgencySettingsCustomDomainPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_domain"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/facebook/status(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusBusinessIntegrationsFacebookPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/gbp/status(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusBusinessIntegrationsGbpPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gbp"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/gsc/status(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusBusinessIntegrationsGscPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gsc"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeWebhookPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/website/subdomain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subdomainAgencySettingsWebsitePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[6,"subdomain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/accounts/:id/switch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switchAdminAffiliateAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"switch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/agency_accounts/:id/switch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switchAdminAgencyAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"agency_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"switch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_accounts/:id/switch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switchAdminBusinessAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"switch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_accounts/:id/switch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switchAdminVendorAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"switch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:id/switch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switchAgencyBusinessAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"switch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/solo_checkout/tax_preview(.:format)
 * @param {any} businessAccountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxPreviewAgencyBusinessAccountSoloCheckoutPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"solo_checkout"],[2,[7,"/"],[2,[6,"tax_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:agency_uid/plan/marketing_analyses/:marketing_analysis_id/checkout/tax_preview(.:format)
 * @param {any} agencyUid
 * @param {any} marketingAnalysisId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxPreviewPlanMarketingAnalysisCheckoutPath = /*#__PURE__*/ __jsr.r({"agency_uid":{"r":true},"marketing_analysis_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"agency_uid"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"marketing_analyses"],[2,[7,"/"],[2,[3,"marketing_analysis_id"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"tax_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/imports/template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const templateAgencyLeadImportsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[6,"template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/lead_feed/test(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testVendorOrderLeadFeedPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"lead_feed"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/products/:id/toggle_active(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleActiveAgencyProductPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements/:id/toggle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAdminAnnouncementPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/leads/autopilot/toggle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAgencyProspectingAutopilotPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"autopilot"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /unbounce/webhook/:business_uid/:token(.:format)
 * @param {any} businessUid
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unbounceWebhookPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unbounce"],[2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/affiliate/asset_library/assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAssetAdminAffiliateAssetLibraryIndexPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"affiliate"],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:id/update_payload(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePayloadVendorOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_payload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGoogleOauth2OmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGoogleOauth2OmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/magic_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userMagicLinkPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"magic_link"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /profile/phone(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userProfilePhonePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"phone"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2/start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAuthGoogleOauth2StartPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/sso/finish(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAuthSsoFinishPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/sso/start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAuthSsoStartPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/magic_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersMagicLinkPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"magic_link"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/preference(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersPreferencePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"preference"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor/invitations/:token/accept(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorAcceptInvitationPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/switch/:uid(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorAccountSwitchPath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"switch"],[2,[7,"/"],[2,[3,"uid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/clients/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorClientPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/clients/:client_id/report(.:format)
 * @param {any} clientId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorClientReportPath = /*#__PURE__*/ __jsr.r({"client_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"client_id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/clients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorClientsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorInvoicesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor/message_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorMessageTemplatePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"message_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/archival(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderArchivalPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"archival"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/campaign_links(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderCampaignLinksPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"campaign_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/client_approval(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderClientApprovalPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"client_approval"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/completion(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderCompletionPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"completion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/ga4_measurement_id(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderGa4MeasurementIdPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"ga4_measurement_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/landing_page_domain(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderLandingPageDomainPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"landing_page_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/lead_feed(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderLeadFeedPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"lead_feed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/messages(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderMessagesPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/sms_addon_offer(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderSmsAddonOfferPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"sms_addon_offer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/tracking_number(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderTrackingNumberPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"tracking_number"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/website_go_live(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderWebsiteGoLivePath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"website_go_live"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/website_review_edit(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderWebsiteReviewEditPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"website_review_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/website_review_round(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderWebsiteReviewRoundPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"website_review_round"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/wix_account_email(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderWixAccountEmailPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"wix_account_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/wix_account_email_request(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderWixAccountEmailRequestPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"wix_account_email_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/wix_domain_records(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderWixDomainRecordsPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"wix_domain_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/wix_handoff_bundle(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderWixHandoffBundlePath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"wix_handoff_bundle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/wix_handoff_report(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderWixHandoffReportPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"wix_handoff_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/wix_publish(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderWixPublishPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"wix_publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/wix_setup_approval(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderWixSetupApprovalPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"wix_setup_approval"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/wix_setup_edit(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderWixSetupEditPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"wix_setup_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/yext_listing_retry(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderYextListingRetryPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"yext_listing_retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders/:order_id/yext_sso(.:format)
 * @param {any} orderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrderYextSsoPath = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"yext_sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorOrdersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor/quote_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorQuoteRequestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"quote_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/quote_requests/:quote_request_id/declination(.:format)
 * @param {any} quoteRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorQuoteRequestDeclinationPath = /*#__PURE__*/ __jsr.r({"quote_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"quote_requests"],[2,[7,"/"],[2,[3,"quote_request_id"],[2,[7,"/"],[2,[6,"declination"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/quote_requests/:quote_request_id/messages(.:format)
 * @param {any} quoteRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorQuoteRequestMessagesPath = /*#__PURE__*/ __jsr.r({"quote_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"quote_requests"],[2,[7,"/"],[2,[3,"quote_request_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/quote_requests/:quote_request_id/quote(.:format)
 * @param {any} quoteRequestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorQuoteRequestQuotePath = /*#__PURE__*/ __jsr.r({"quote_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"quote_requests"],[2,[7,"/"],[2,[3,"quote_request_id"],[2,[7,"/"],[2,[6,"quote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/quote_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorQuoteRequestsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"quote_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor/receptionist_console_sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorReceptionistConsoleSsoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"receptionist_console_sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /vendor/settings/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorSettingsIntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/settings/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorSettingsUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/settings/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorSettingsUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendor/website_builder_sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorWebsiteBuilderSsoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"website_builder_sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor/yext_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorYextCategoriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"yext_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/custom_domain/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyAgencySettingsCustomDomainPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_domain"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/settings/sender_domain/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyAgencySettingsSenderDomainPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sender_domain"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/landing_page_domains/:id/verify(.:format)
 * @param {any} businessUid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyBusinessLandingPageDomainPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"landing_page_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /business/:business_uid/integrations/facebook/verify_created_assets(.:format)
 * @param {any} businessUid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyCreatedAssetsBusinessIntegrationsFacebookPath = /*#__PURE__*/ __jsr.r({"business_uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business"],[2,[7,"/"],[2,[3,"business_uid"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"verify_created_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_invoices/:uid/void(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voidAdminVendorInvoicePath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_invoices"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"void"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agency/business_accounts/:business_account_id/plan_agreements/:uid/void(.:format)
 * @param {any} businessAccountId
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voidAgencyBusinessAccountPlanAgreementPath = /*#__PURE__*/ __jsr.r({"business_account_id":{"r":true},"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agency"],[2,[7,"/"],[2,[6,"business_accounts"],[2,[7,"/"],[2,[3,"business_account_id"],[2,[7,"/"],[2,[6,"plan_agreements"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"void"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/calendly(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksCalendlyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"calendly"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/dataforseo/ad_traffic_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksDataforseoAdTrafficTasksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"dataforseo"],[2,[7,"/"],[2,[6,"ad_traffic_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/dataforseo/ads_search_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksDataforseoAdsSearchTasksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"dataforseo"],[2,[7,"/"],[2,[6,"ads_search_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/dataforseo/prospecting_maps_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksDataforseoProspectingMapsTasksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"dataforseo"],[2,[7,"/"],[2,[6,"prospecting_maps_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/dataforseo/search_volume_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksDataforseoSearchVolumeTasksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"dataforseo"],[2,[7,"/"],[2,[6,"search_volume_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/dataforseo/serp_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksDataforseoSerpTasksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"dataforseo"],[2,[7,"/"],[2,[6,"serp_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/impact/actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksImpactActionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"impact"],[2,[7,"/"],[2,[6,"actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/ureception(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksUreceptionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"ureception"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/usites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksUsitesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"usites"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /websites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSignupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"websites"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /websites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websitesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"websites"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /vendor/invoices/:uid/withdraw(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const withdrawVendorInvoicePath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"withdraw"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vendor_invoices/:uid/write_off(.:format)
 * @param {any} uid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const writeOffAdminVendorInvoicePath = /*#__PURE__*/ __jsr.r({"uid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vendor_invoices"],[2,[7,"/"],[2,[3,"uid"],[2,[7,"/"],[2,[6,"write_off"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

